import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerHelper } from '../../../helpers/spinner.helper';
import { ToastrHelper } from '../../../helpers/toastr.helper';
import { Event } from '../../../models/events/event.model';
import { EventsService } from '../../../services/events/events.service';
import { DialogBase } from '../../../events/directives/dialog-base.directive';
import { Router } from '@angular/router';

@Component({
    selector: 'dialog-join-event',
    template: `
        <p-dialog
            header="{{ 'events.modals.join.title' | translate }}"
            [(visible)]="isModalDisplayed"
            [modal]="true"
            [draggable]="false"
            [resizable]="false"
            [dismissableMask]="true"
            (onHide)="closeModal()"
        >
            <div class="mt-4 text-center">
                <p>{{ 'events.modals.join.message' | translate : { eventTitle : event.name} }}</p>
                <p>{{ 'events.modals.join.confirmationMessage' | translate }}</p>
            </div>

            <p-footer>
                <button pButton class="p-button-text" [label]="'events.modals.join.cancel' | translate" (click)="closeModal()"></button>
                <button pButton *ngIf="displaySeeMoreButton" class="p-button-text" [label]="'events.modals.join.seeMore' | translate" (click)="seeMore()"></button>
                <button pButton [label]="'events.modals.join.confirm' | translate" (click)="joinEvent()"></button>
            </p-footer>
        </p-dialog>
    `,
})
export class DialogJoinEventComponent extends DialogBase {
    @Input() public event: Event;
    @Input() public displaySeeMoreButton: boolean = false;

    constructor(
        private readonly spinnerHelper: SpinnerHelper,
        private readonly eventService: EventsService,
        private readonly translate: TranslateService,
        private readonly toastrHelper: ToastrHelper,
        private router: Router,
    ) {
        super();
    }

    public async joinEvent(): Promise<void> {
        this.spinnerHelper.showSpinner();

        try {
            await this.eventService.joinEvent(this.event.id).toPromise();

            const msg = this.translate.instant('events.modals.join.toast.success');
            this.toastrHelper.showSuccess(msg);
            this.acted.emit();
        } catch (error: any) {
            this.toastrHelper.showGenericError(error);

            // Could be a concurrent exception, so reload the event anyway
            this.acted.emit();
        } finally {
            this.spinnerHelper.hideSpinner();
            this.closeModal();
        }
    }

    public seeMore(): void{
        this.router.navigate(['events', this.event.id]);
        this.closeModal();
    }
}
